export default __webpack_public_path__ + "static/media/dozule19.3631392b.jpg";